// Modals, error handling, and validation dictionary
const dictModals = {
    // General modal functionality
    modal_loading: {
        th: "กำลังโหลด...",
        en: "Loading...",
        ja: "読込中...",
    },
    modal_error: {
        th: "เกิดข้อผิดพลาดในการโหลดข้อมูล",
        en: "Error loading data",
        ja: "データ読み込みエラー",
    },
    modal_close: {
        th: "ปิด",
        en: "Close",
        ja: "閉じる",
    },
    modal_retry: {
        th: "ลองใหม่",
        en: "Retry",
        ja: "再試行",
    },

    // Post modal specific
    loading_post: {
        th: "กำลังโหลดโพสต์...",
        en: "Loading post...",
        ja: "投稿読込中...",
    },
    loading_images: {
        th: "กำลังโหลดภาพ...",
        en: "Loading images...",
        ja: "画像読込中...",
    },
    processing_images: {
        th: "กำลังประมวลผลภาพ...",
        en: "Processing images...",
        ja: "画像処理中...",
    },
    finalizing_content: {
        th: "กำลังเตรียมเนื้อหา...",
        en: "Finalizing content...",
        ja: "コンテンツ準備中...",
    },
    sending_data: {
        th: "กำลังส่งข้อมูล...",
        en: "Sending data...",
        ja: "送信中...",
    },
    optimizing_images: {
        th: "กำลังปรับปรุงภาพ...",
        en: "Optimizing images...",
        ja: "画像最適化中...",
    },

    // Additional loading states for create.blade.php
    loading_submitting: {
        th: "กำลังส่งโพสต์...",
        en: "Submitting post...",
        ja: "投稿送信中...",
    },
    loading_rotating: {
        th: "กำลังหมุนภาพ...",
        en: "Rotating image...",
        ja: "画像回転中...",
    },
    loading_preparing: {
        th: "กำลังเตรียมตัวอย่าง...",
        en: "Preparing preview...",
        ja: "プレビュー準備中...",
    },
    loading_image: {
        th: "กำลังประมวลผลภาพ...",
        en: "Processing image...",
        ja: "画像処理中...",
    },
    post_load_error: {
        th: "เกิดข้อผิดพลาดในการโหลดโพสต์",
        en: "Error loading post",
        ja: "投稿の読み込みエラー",
    },
    post_not_found: {
        th: "ไม่พบโพสต์",
        en: "Post not found",
        ja: "投稿が見つかりません",
    },
    load_failed: {
        th: "การโหลดล้มเหลว",
        en: "Failed to load",
        ja: "読み込みに失敗しました",
    },

    // Generic error messages
    error_occurred: {
        th: "เกิดข้อผิดพลาด",
        en: "An error occurred",
        ja: "エラーが発生しました",
    },
    session_expired_login_required: {
        th: "เซสชันหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ คุณต้องการไปที่หน้าเข้าสู่ระบบหรือไม่?",
        en: "Your session has expired. Please log in again to continue. Would you like to go to the login page?",
        ja: "セッションが切れました。続行するには再度ログインしてください。ログインページに移動しますか？",
    },
    session_expired_reloading: {
        th: "เซสชันหมดอายุแล้ว กำลังโหลดหน้าใหม่...",
        en: "Session expired. Reloading...",
        ja: "セッションが切れました。ページを再読み込みします...",
    },
    csrf_mismatch: {
        th: "CSRF token ไม่ตรงกัน กรุณาโหลดหน้าเว็บใหม่และลองอีกครั้ง",
        en: "CSRF token mismatch. Please reload the page and try again.",
        ja: "CSRFトークンが一致しません。ページを再読み込みして再試行してください。",
    },

    // Validation messages
    title_content_required: {
        th: "กรุณากรอกหัวข้อและเนื้อหา",
        en: "Title and content are required.",
        ja: "タイトルと内容は必須です。",
    },
    content_required: {
        th: "กรุณากรอกเนื้อหา",
        en: "Content is required.",
        ja: "内容は必須です。",
    },

    // Success messages
    post_updated: {
        th: "อัปเดตโพสต์เรียบร้อยแล้ว!",
        en: "Post updated successfully!",
        ja: "投稿が正常に更新されました！",
    },
    post_deleted: {
        th: "ลบโพสต์เรียบร้อยแล้ว",
        en: "Post deleted successfully",
        ja: "投稿を削除しました",
    },
    post_delete_success_message: {
        th: "โพสต์ถูกลบเรียบร้อยแล้ว คุณต้องการทำอะไรต่อไป?",
        en: "The post has been deleted successfully. What would you like to do next?",
        ja: "投稿が正常に削除されました。次に何をしますか？",
    },

    // Update/edit errors
    post_update_error: {
        th: "ไม่สามารถอัปเดตโพสต์ได้ กรุณาลองใหม่อีกครั้ง",
        en: "Failed to update post. Please try again.",
        ja: "投稿の更新に失敗しました。再試行してください。",
    },

    // Reporting
    report_submitted: {
        th: "ส่งรายงานแล้ว",
        en: "Report submitted",
        ja: "報告を送信しました",
    },

    // Navigation actions in modals
    back_to_board: {
        th: "กลับไปที่บอร์ด",
        en: "Back to Board",
        ja: "ボードに戻る",
    },
    go_home: {
        th: "ไปหน้าแรก",
        en: "Go Home",
        ja: "ホームに戻る",
    },

    // SNS maximize modal
    sns_maximize_dialog_label: {
        th: "เครื่องเล่นสื่อ",
        en: "Media Viewer",
        ja: "メディアビューア",
    },
    sns_maximize_iframe_title: {
        th: "เนื้อหา SNS",
        en: "SNS Content",
        ja: "SNS コンテンツ",
    },

    // Modal content labels
    post_image: {
        th: "รูปภาพโพสต์",
        en: "Post Image",
        ja: "投稿画像",
    },
    untitled: {
        th: "ไม่มีชื่อ",
        en: "Untitled",
        ja: "無題",
    },
    author: {
        th: "ผู้โพสต์",
        en: "Author",
        ja: "投稿者",
    },
    created_date: {
        th: "วันที่สร้าง",
        en: "Created Date",
        ja: "作成日",
    },
    content: {
        th: "เนื้อหา",
        en: "Content",
        ja: "内容",
    },

    // Login/Authentication for modals
    add_comment: {
        th: "ความคิดเห็น",
        en: "Comment",
        ja: "コメント",
    },
    comment_login_required: {
        th: "ในการแสดงความคิดเห็นต้อง",
        en: "To comment, please",
        ja: "コメントするには",
    },
    comment_login_needed: {
        th: "ก่อน",
        en: "first",
        ja: "してください",
    },
    login: {
        th: "เข้าสู่ระบบ",
        en: "Login",
        ja: "ログイン",
    },

    // Edit functionality errors
    post_edit_modal_only: {
        th: "การแก้ไขโพสต์สามารถทำได้ในโหมดป็อปอัปเท่านั้น",
        en: "Post editing is only available in popup mode",
        ja: "投稿の編集はポップアップモードでのみ可能です",
    },
    modal_post_editor_not_initialized: {
        th: "ไม่สามารถเปิดฟอร์มแก้ไขได้ กรุณาลองใหม่อีกครั้ง",
        en: "Cannot open edit form. Please try again.",
        ja: "編集フォームを開けません。もう一度お試しください。",
    },
    comment_edit_not_available: {
        th: "ไม่สามารถแก้ไขความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง",
        en: "Cannot edit comment. Please try again.",
        ja: "コメントを編集できません。もう一度お試しください。",
    },
    comment_delete_not_available: {
        th: "ไม่สามารถลบความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง",
        en: "Cannot delete comment. Please try again.",
        ja: "コメントを削除できません。もう一度お試しください。",
    },
    modal_cannot_close_while_editing: {
        th: "ไม่สามารถปิดขณะแก้ไขได้",
        en: "Cannot close while editing",
        ja: "編集中は閉じられません",
    },
    modal_click_outside_to_close: {
        th: "กรุณาใช้ปุ่มปิดเพื่อปิดหน้าต่าง",
        en: "Please use the close button to close the modal",
        ja: "閉じる場合は×ボタンを押してください",
    },
};

export { dictModals };
